<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/coming-soon.html" name="c-coming-soon">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">


<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>
	<c-header></c-header>

	<div class="p-new-jsdelivr old-text-page">
		<div class="container">
			<div class="row">
				<div class="col-md-9">
					<h1 class="page-title">The new jsDelivr</h1>

					<section>
						<h3>What happened?</h3>

						<p>
							We switched from manual file uploads to a fully automated system. You can <a href="/features">read more about it here</a>.
						</p>

						<h3>As a user, do I need to do anything?</h3>

						<p>
							No. All existing links will continue to work, and there is no action required on your end.
							However, the legacy projects no longer receive updates. To use the latest available version,
							you'll need to switch to one of our new endpoints.
						</p>

						<h3>As a project author, do I need to do anything?</h3>

						<p>
							Yes. You should update your documentation to use one of our new endpoints.
							New versions of your project won't be available at the legacy endpoint.
							Our new endpoints have many interesting features, including detailed project usage statistics!
						</p>
					</section>
				</div>
			</div>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	component.exports = {
		data () {
			return {
				title: 'The New jsDelivr',
			};
		},
	};
</script>
